module.exports = __webpack_public_path__ + "static/media/subatomic.ad4e9bfa.png";